import { required, between } from 'vuelidate/lib/validators';
import { MY_RUN } from '@/graphql.gql';
import defaultConfig from '@/config.run';
import _ from 'lodash';

export default {
  data() {
    return {
      myRun: { id: -1, status: 'B', config: _.cloneDeep(defaultConfig), dataSet: [] },
    };
  },
  validations: {
    myRun: {
      config: {
        name: {
          required,
        },
        coronal_model: {
          Magnetogram: {
            degrees_per_pixel: {
              required,
              between: between(0.5, 8),
            },
            gaussian_smoothing_sd: {
              required,
              between: between(0, 3),
            },
          },
          PFSS: {
            source_surface_radius: {
              required,
              between: between(1.8, 3),
            },
            number_of_radial_grid_pts: {
              required,
              between: between(64, 256),
            },
            max_degree: {
              required,
              between: between(40, 140),
            },
          },
          SCS: {
            start_radius: {
              required,
              between: between(1.8, 3),
            },
            end_radius: {
              required,
            },
            number_of_radial_grid_pts: {
              required,
              between: between(64, 256),
            },
            max_degree: {
              required,
              between: between(40, 140),
            },
          },
          HeliosphereBoundary: {
            degrees_per_pixel: {
              required,
              between: between(0.5, 8),
            },
            wind_speed_relation: {
              required,
            },
            rotate: {
              required,
              between: between(-15, -5),
            },
            speed: {
              add: {
                required,
                between: between(-100, 100),
              },
              max: {
                required,
                between: between(200, 1000),
              },
              min: {
                required,
                between: between(100, 500),
              },
            },
            fast_solar_wind: {
              magnetic_field: {
                required,
                between: between(100, 500),
              },
              number_density: {
                required,
                between: between(50, 500),
              },
            },
            solar_wind: {
              pressure: {
                required,
                between: between(1, 10),
              },
            },
          },
        },
        heliospheric_model: {
          Grid: {
            num_radial: {
              required,
              between: between(128, 1024),
            },
            angular_resolution: {
              required,
              between: between(0.5, 8),
            },
            radial: {
              outer_edge: {
                required,
                between: between(1, 10),
              },
            },
          },
          cluster: {
            walltime: {
              required,
            },
            nodes: {
              required,
              between: between(1, 10),
            },
            account: {
              required,
            },
          },
        },
      },
    },
  },
  apollo: {
    myRun: {
      query: MY_RUN,
      variables() {
        return { id: this.$route.params.id };
      },
      update({ myRun }) {
        if (typeof myRun.config === 'string') {
          // eslint-disable-next-line no-param-reassign
          myRun.config = JSON.parse(myRun.config);
        }
        return myRun;
      },
      watchLoading(isLoading) {
        if (isLoading && !this.$wait.is('busy')) {
          this.$wait.start('busy');
        } else if (!isLoading && this.$wait.is('busy')) {
          this.$wait.end('busy');
        }
      },
    },
  },
  computed: {
    expertMode: {
      get() {
        return this.$store.getters.expertMode;
      },
      set(newMode) {
        this.$store.dispatch('setExpertMode', newMode);
      },
    },
  },
  methods: {
    errorMessages(vuelidateObj) {
      const errors = [];
      if (!vuelidateObj.$dirty) return errors;
      if ('required' in vuelidateObj && !vuelidateObj.required) {
        errors.push('Required.');
      }
      if ('between' in vuelidateObj && !vuelidateObj.between) {
        errors.push(
          'Required to be greater than ' +
            vuelidateObj.$params.between.min +
            ' and less than ' +
            vuelidateObj.$params.between.max +
            '.'
        );
      }
      if ('minValue' in vuelidateObj && !vuelidateObj.minValue) {
        errors.push('Required to be greater than ' + vuelidateObj.$params.minValue.min + '.');
      }
      return errors;
    },
  },
};
